// import { CurrentUserContext } from '../../context/CurrentUserContext.js';
import { useContext, useTransition, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../utils/hooks/translateHook.js';
import arrow from "../../images/icons/ArrowIcon.svg"
import {useCurrentCourseSlug} from "../../utils/getCurrentCourseSlug.js";
import bgVideo from '../../images/video-hq-small.mp4';
import './Welcome.css';

function CoverPage({user}) {
  // const { currentUser } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const t = useTranslation();
  const courseSlug = useCurrentCourseSlug();
  // const course = courseRegistry[courseSlug];
  const handleClick = () => { navigate(`/course/${courseSlug}/content`); };

  // if (!course) return null;

  const coursePath = (path) => {
    if (!courseSlug) return "/courses";
    return `/course/${courseSlug}${path}`
  }

    // useEffect(() => {
    //   const timer = setTimeout(() => {
    //     navigate('/course/html/content');
    //   }, 8000);
    //   return () => clearTimeout(timer);
    // }, [navigate]);


  return(
    <main>
      <video className="bg-video" autoPlay muted loop playsInline>
         <source src={bgVideo} type="video/mp4" />
      </video>

      <div className="overlayContent">
        <div className="bubble" onClick={handleClick}>
          <div className="line1"> {t('welcomeMain')} <span className="first">{t('welcomeSub1')}</span></div>
          <div className="line2"> {t('welcomeSub2')} </div>
        </div>
        <div className="line" onClick={handleClick}>
            <p className="line-btn">{t('start')}</p>
            <div className="line-btn icon-btn"> <img src={arrow} alt="" className="arr-icon"/></div>
        </div>
      </div>
    </main>
  )
}

export default CoverPage;